import React, { useEffect, useState } from "react";
import Seo from "../../../Components/SeoComponent/Seo";
import Header from "../../../Components/Header";
import { useService } from "../../../context/ServiceContext";
import {
  AlertCircle,
  ArrowRight,
  Cog,
  FileCheck,
  Gauge,
  Loader,
  ShieldCheck,
} from "lucide-react";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { isAlphanumeric } from "validator";
import { checkTransUnionReportHybrid } from "../../../Services/EquifaxCScore/highmark";
import { getServiceNameAndDetails } from "../../../Services";
import SummaryScore from "./SummaryScore";

function TransunionHybrid() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const endPoint = "/srv5/transunion-Score-Hybrid";
  const [serviceName, setServiceName] = useState("");

  const [firstName, setFirstName] = useState("");
  const [dob, setDob] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [gender, setGender] = useState("");
  const [pan, setPan] = useState("");
  const [inputError, setInputError] = useState(null);

  const [profileData, setProfileData] = useState(null);
  const [score, setScore] = useState(response);
  let apiResponse;

  const handleReport = async () => {
    if (!profileData) return;

    if (!lastName || !firstName || !gender || !mobile || !pan) {
      return setInputError(
        "firstName, lastName, gender, mobile, pan fields are Required",
      );
    }

    if (mobile && mobile?.length < 10) {
      return setInputError("⚠️ Please enter 10 digits in Mobile No. field");
    }

    try {
      setInputError(null);
      setIsLoading(true);
      setResponse(null);

      const res = await checkTransUnionReportHybrid({
        api_id: profileData.user_id,
        api_key: profileData.api_key,
        token_id: profileData.token_id,
        forename: firstName.trim(),
        surname: lastName.trim(),
        gender,
        dob,
        pan_id: pan,
        phone_number: mobile,
      });

      if (res) {
        apiResponse = res;
        console.log(res);
      }
      setResponse(apiResponse);

      if (res?.status?.code === 200) {
        showSuccessToast(res?.message || "Success");
      } else {
        // showErrorToast(res?.data?.message || "invalid details ");
        const err = res?.error || res?.data?.errors;

        const errMsg = Object.values(err || {});

        errMsg?.map((item, idx) => showErrorToast(item[0]));

        console.log("error message", res.data?.error);

        showErrorToast(
          res.data?.error ||
            res?.data?.message ||
            res?.message ||
            res?.data?.data?.message ||
            "Validation Failed",
        );
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------------- FETCH PROFILE ----------------
  useEffect(() => {
    const loadProfile = async () => {
      try {
        setIsLoading(true);
        const res = await fetchProfile();
        setProfileData(res?.data || null);
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  useEffect(() => {
    const getServiceName = async () => {
      try {
        const res = await getServiceNameAndDetails({
          end_point: endPoint,
        });

        if (res?.status?.code === 200) {
          setServiceName(res?.data?.service_name);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getServiceName();
  }, []);

  return (
    <>
      <Seo />
      <Header heading={serviceName} />

      {isLoading && (
        <div className="flex justify-center mt-6">
          <Loader className="animate-spin" />
        </div>
      )}

      <div className="w-full min-h-screen flex flex-col items-center justify-start pb-14">
        {/* ---------------- FORM ---------------- */}
        <div className=" w-full mt-2 rounded-2xl border border-slate-200 bg-white px-6 py-2 shadow-xl shadow-slate-100">
          {/* Header */}
          <div className="flex items-center gap-3 border-b border-slate-100 pb-5">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600">
              <Gauge size={24} />
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-800">
                Transunion Hybrid Report
              </h2>
              <p className="text-sm text-slate-500">
                Get Transunion Report using Name, mobile, pan and gender.
              </p>
            </div>
          </div>

          {/* Inputs */}
          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3 xl:grid-cols-5">
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                First Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Eg: Abhishek"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>

            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Last Name <span className="text-red-500">*</span>
              </label>

              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Eg: Kumar"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Mobile <span className="text-red-500">*</span>
              </label>

              <input
                type="number"
                value={mobile}
                maxLength={10}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="Eg: 9699869587"
                className="w-full rounded-xl border border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                PAN <span className="text-red-500">*</span>
              </label>

              <input
                type="text"
                value={pan}
                maxLength={10}
                onChange={(e) => setPan(e.target.value)}
                placeholder="Eg: BTUPJ4358H"
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Gender <span className="text-red-500">*</span>
              </label>

              <select
                onChange={(e) => setGender(e.target.value)}
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
                name="gender"
                id="gender"
              >
                <option value="">Select</option>
                <option value="Male">MALE</option>
                <option value="Female">FEMALE</option>
              </select>
            </div>
            <div>
              <label className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700">
                <ShieldCheck size={17} className="text-blue-600" />
                Date Of Birth (Optional)
              </label>

              <input
                type="date"
                value={dob}
                maxLength={10}
                onChange={(e) => setDob(e.target.value)}
                className="w-full rounded-xl border uppercase border-slate-300 px-4 py-2 text-sm transition-all duration-200 placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
          </div>
          <DeepIndigoNotice />

          {/* Error */}
          {inputError && (
            <div className="mt-5 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-red-700">
              <AlertCircle size={18} />
              <span className="text-sm font-medium">{inputError}</span>
            </div>
          )}

          {/* Button */}
          <div className="mt-8 flex justify-end">
            <button
              disabled={
                isLoading ||
                !lastName ||
                !firstName ||
                !mobile ||
                !gender ||
                !pan
              }
              onClick={handleReport}
              className="group inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 px-7 py-3 font-semibold text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isLoading ? (
                <>
                  <Cog size={18} className="animate-spin" />
                  Verifying...
                </>
              ) : (
                <>
                  Get Report
                  <ArrowRight
                    size={18}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </>
              )}
            </button>
          </div>
        </div>

        {/* ---------------- RESULT ---------------- */}
        {response?.status?.code === 200 && (
          <SummaryScore responseData={response} />
        )}
      </div>
    </>
  );
}

export default TransunionHybrid;

function DeepIndigoNotice() {
  return (
    <div className="relative mt-2 overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-700 via-blue-600 to-violet-700 p-0.5 shadow-xl shadow-indigo-500/20">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 rounded-[15px]  p-1 sm:p-2 backdrop-blur-xl text-white">
        <div className="flex items-center gap-3.5">
          {/* Glowing Icon Badge */}
          <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 text-white shadow-md shadow-indigo-500/40 ring-1 ring-white/20">
            <ShieldCheck className="h-6 w-6" />
          </div>

          <div>
            {/* <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-amber-400">
              <Sparkles className="h-3.5 w-3.5" />
              High-Precision Report
            </div> */}
            <p className="text-sm sm:text-base font-semibold text-slate-100 mt-0.5">
              Complete all required fields Above to generate a{" "}
              <span className="font-bold text-amber-300 underline decoration-amber-400/50 underline-offset-4">
                100% accurate report
              </span>
              .
            </p>
          </div>
        </div>

        <div className="shrink-0 rounded-xl bg-amber-400/10 px-3.5 py-1.5 text-xs font-bold text-amber-300 ring-1 ring-amber-400/30 flex items-center gap-1.5">
          <FileCheck className="h-4 w-4" />
          Precision Processing
        </div>
      </div>
    </div>
  );
}
